<template>
  <div class="main">
    <TabListCon :divType="divTypes"></TabListCon>
    <img src="../../static/imgs/bg3.png" class="img" />
    <div class="titleText">
      <div class="title">绿色建筑</div>
      <div class="textMs">让高品质民居走进千家万户</div>
    </div>
    <div class="box">
      <div class="titleName">产品详情</div>
      <div class="detaisMain">
        <div class="detailsListText">
          <div class="nameMore">
            <div class="name">感恩系列G1</div>
            <div class="textIcon" @click="handleG1">
              <div class="more">了解更多</div>
              <img src="../../static/imgs/share.png" class="icon" />
            </div>
          </div>
          <div class="line"></div>
          <div class="nameMore">
            <div class="name">感恩系列G2</div>
            <div class="textIcon" @click="handleG2">
              <div class="more">了解更多</div>
              <img src="../../static/imgs/share.png" class="icon" />
            </div>
          </div>
        </div>
        <div class="detailsList">
          <div class="modeMain">
            <!-- <div class="modeType">访华系列</div>
            <div class="modeText">适用于即将步入新的人生阶段的新婚家庭。</div> -->
            <div class="typeFh">
              <div class="textIconType" @click="handleF1">
                <div class="more">芳华系列F1</div>
                <img src="../../static/imgs/share.png" style="width: 32px;height: 32px;" />
              </div>
              <div class="textIconType" @click="handleF2">
                <div class="more">芳华系列F2</div>
                <img src="../../static/imgs/share.png" style="width: 32px;height: 32px;" />
              </div>
            </div>
          </div>
          <img src="../../static/imgs/fhxl.jpg" />
        </div>
        <div class="detailsList">
          <div class="modeMain">
            <!-- <div class="modeType">乡情系列</div>
            <div class="modeText">适合衣锦还乡，荣归故里的家庭。</div> -->
            <div class="typeFh">
              <div class="textIconType" @click="handleX1">
                <div class="more">乡情系列X1</div>
                <img src="../../static/imgs/share.png" style="width: 32px;height: 32px;" />
              </div>
              <div class="textIconType" @click="handleX2">
                <div class="more">乡情系列X2</div>
                <img src="../../static/imgs/share.png" style="width: 32px;height: 32px;" />
              </div>
            </div>
          </div>
          <img src="../../static/imgs/xqxl.jpg" />
        </div>
        <div class="detailsList">
          <div class="modeMain">
            <!-- <div class="modeType">昆玉系列</div>
            <div class="modeText">适合兄弟姐妹联排建房的家庭。</div> -->
            <div class="typeFh">
              <div class="textIconType" @click="handleK1">
                <div class="more">昆玉系列K1</div>
                <img src="../../static/imgs/share.png" style="width: 32px;height: 32px;" />
              </div>
              <div class="textIconType" @click="handleK2">
                <div class="more">昆玉系列K2</div>
                <img src="../../static/imgs/share.png" style="width: 32px;height: 32px;" />
              </div>
            </div>
          </div>
          <img src="../../static/imgs/kyxl.jpg" />
        </div>
      </div>
    </div>
    <img src="../../static/imgs/cpys.jpg" class="imgJs" />
    <img src="../../static/imgs/bj.jpg" class="imgJs" />
    <img src="../../static/imgs/bz.jpg" class="imgJs" />
    <img src="../../static/imgs/jflc.jpg" class="imgJs" />
    <!-- 这边有背景图 貌似是文字轮播图 直接挂图片所以现在不好看 -->
    <!-- <div class="boxSwiper">
      <div class="actionSwiper">
        <img src="../../static/imgs/swiperLeft.png" @click="handleLeft"></img>
        <van-swipe :autoplay="3000" :touchable="true" ref="swiper" class="swiper">
          <van-swipe-item v-for="(item, index) in images" :key="index">
            <img v-lazy="item" style="width: 100%;height: 100vh;" />
          </van-swipe-item>
        </van-swipe>
        <img src="../../static/imgs/swiperRight.png" @click="handleRight"></img>
      </div>
    </div> -->
    <!-- <img src="https://img01.yzcdn.cn/vant/cat.jpeg" class="contentImg" /> -->
    <!-- <div class="titleName">铭安潮居装配式九大建房保障</div>
    <div class="afterSalesContent">
      <div class="afterSalesContentList" v-for="(item, index) in afterSalesContentData" :key="index">
        <img :src="item.image" />
        <div class="afterSalesContentText">{{ item.name }}</div>
      </div>
    </div> -->
    <!-- <BottomContentCon></BottomContentCon> -->
  </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
import { ImagePreview } from 'vant';

export default {
  name: "Home",
  data() {
    return {
      afterSalesContentData: [
        { image: require('../../static/imgs/AfterSales1.png'), name: '售后保障' },
        { image: require('../../static/imgs/AfterSales2.png'), name: '智能交互' },
        { image: require('../../static/imgs/AfterSales3.png'), name: '顶尖工艺' },
        { image: require('../../static/imgs/AfterSales4.png'), name: '环保材质' },
        { image: require('../../static/imgs/AfterSales5.png'), name: '国资背景' },
        { image: require('../../static/imgs/AfterSales6.png'), name: '金融服务' },
        { image: require('../../static/imgs/AfterSales7.png'), name: '先进设计' },
        { image: require('../../static/imgs/AfterSales8.png'), name: '物流配送' },
        { image: require('../../static/imgs/AfterSales9.png'), name: '线上管理' },
      ],
      divTypes: '3',//顶部Tab组件的index值
      images: [
        'https://img01.yzcdn.cn/vant/cat.jpeg',
        'https://img01.yzcdn.cn/vant/cat.jpeg',
        'https://img01.yzcdn.cn/vant/cat.jpeg',
      ],
    }
  },
  components: { TabListCon, BottomContentCon },
  created() {

  },
  mounted() {

  },
  methods: {
    handleK2() {
      this.$router.push("/KtwoDetail")
    },
    handleK1() {
      this.$router.push("/KoneDetail")
    },
    handleX2() {
      this.$router.push("/XtwoDetail")
    },
    handleX1() {
      this.$router.push("/XoneDetail")
    },
    handleF1() {
      this.$router.push("/FoneDetail")
    },
    handleF2() {
      this.$router.push("/FtwoDetail")
    },
    handleG2() {
      this.$router.push("/GtwoDetail")
    },
    handleG1() {
      this.$router.push("/GoneDetail")
    },
    //可以无兼容问题
    handleLeft() {
      this.$refs.swiper.prev()
    },
    handleRight() {
      this.$refs.swiper.next()
    }
  }
};
</script>

<style scoped>
.imgJs {
  width: 100%;
}

.typeFh {
  margin-top: 420px;
  margin-left: 16px;
}

.rightIcons {
  width: 24px;
  height: 12px;
}

.afterSalesContent {
  background-color: #114035;
  padding: 100px 170px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.afterSalesContentList {
  width: 158px;
}

.afterSalesContentList img {
  width: 64px;
  height: 64px;
  text-align: center;
  display: block;
  margin: 0 auto;
}

.afterSalesContentText {
  font-size: 24px;
  color: #fff;
  text-align: center;
}

.contentImg {
  width: 100%;
  height: 2147px;
  margin-top: 108px;
}

.actionSwiper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actionSwiper img {
  width: 108px;
  height: 108px;
  display: block;
}

.swiper {
  width: 1397px;
  height: 472px;
}

.detailsList {
  text-align: center;

}

.modeMain {
  position: absolute;
  margin-top: 48px;
  margin-left: 76px;
}

.modeText {
  font-size: 21px;
  color: #333333;
  line-height: 32px;
  width: 237px;
  margin: 0 auto;
}

.modeType {
  font-size: 40px;
  color: #114035;
  font-weight: bold;
}

.detailsListText {
  width: 390px;
  height: 684px;
  background-color: #114035;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* 行与行之间留有均匀间隔。 */
  padding: 108px 99px;
}

.detaisMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.line {
  width: 56px;
  height: 0px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  margin: 0 auto;
}

.textIcon {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 56px;
  line-height: 56px;
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 192px;
  margin-top: 32px;
}

.textIconType {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 56px;
  line-height: 56px;
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 192px;
  margin-top: 32px;
}

.iconFh {
  width: 32px;
  height: 32px;
}

.icon {
  width: 32px;
  height: 32px;
}

.more {
  color: #fff;
  font-size: 22px;
}

.name {
  font-size: 32px;
  color: #FFFFFF;
  font-weight: bold;
  font-family: PingFang SC, PingFang SC;

}

.detailsList img {
  width: 390px;
  height: 684px;
}

.detailsList {
  width: 390px;
  height: 684px;
}



.text {
  font-size: 20px;
  color: #333333;
}

.iconImg {
  width: 84px;
  height: 84px;
  display: block;
}

.erCodeText {
  width: 268px;
  height: 268px;
  text-align: center;
}

.codeImg {
  width: 268px;
  height: 268px;
}

.text {
  color: #979595;
  font-size: 24px;
  line-height: 36px;

}

.titleName {
  color: #333;
  font-size: 64px;
  text-align: center;
  font-weight: bold;
  padding: 160px 0 108px 0;
}


.textMs {
  color: rgba(255, 255, 255, 0.8);
  font-size: 40px;
}

.title {
  color: #fff;
  font-size: 80px;
}

.titleText {
  padding: 145px;
  width: 1500px;
  margin-top: -550px;
  position: absolute;

}

.box {
  padding: 0px 120px 0 120px;

  background: url('../../static/imgs/detailsBg.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}

.boxContent {
  padding: 0px 120px 0 120px;
}

.boxSwiper {
  padding: 0px 120px 0 120px;

  background: url('../../static/imgs/swiperBg.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}

.img {
  width: 100%;
  height: 693px;
}
</style>